// URL Constants
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const RULE_ENGINE_BASE_URL = process.env.REACT_APP_RULE_ENGINE_BASE_URL;
export const S3_URL = process.env.REACT_APP_S3_URL;
export const IDS_BASE_URL = process.env.REACT_APP_IDS_BASE_URL;

export const OKTA_ISSUER = process.env.REACT_APP_ISSUER;
export const OKTA_CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const API_GATEWAY_KEY = process.env.REACT_APP_API_GATEWAY_KEY;

export const SYNC_LOINC_AND_SNOMED = "/syncLoincSnomedCode";
export const LOINC = "/loinc";
export const PAGE = "/page";
export const AOE_LOINC = "/aoeLoinc";
export const REPORTING_LOINC_DATA = "/reportingLoinc/page";
export const REPORTING_LOINC = "/reportingLoinc";
export const LOINC_VIEW = "/loinc/view";
export const LOINC_DATA = "/loinc/page";
export const LOINC_ACTIVE = "/loinc/isactive/true";
export const LOINC_SIZE ="/loinc/size"
export const LOINC_SEARCHTEXT ="/searchText"
export const AOE_LOINC_DATA = "/aoeLoinc/page";
export const CONDITION = "/condition";
export const CONDITION_DATA = "/condition/page";
export const SNOMED = "/snomed";
export const SNOMED_DATA = "/snomed/page";
export const FACILITIES = "/sendingFacility";
export const FACILITIES_DATA = "/sendingFacilityView/page";
export const GET_FACILITIES = "/sendingFacility";
export const PERFORMING_FACILITY = "/performingFacility";
export const PERFORMING_FACILITY_DATA = "/performingFacility/page";
export const RULE = "/rule";
export const RULE_DATA = "/rule/page";
export const TRANSACTION = "/transaction";
export const WITHDELETED = "/with-deleted";
export const DUPLICATE = "/duplicate";
export const MULTIPLE = "/multiple";
export const QAFLAG = "/qaflag";
export const RESTORE_TRANSACTION = "/transaction/restore";
export const DISCARDED_TRANSACTION = "/discardQueue/page";
export const TRANSACTION_DATA = "/transaction/page";
export const TRANSACTION_MESSAGE = "/s3/transaction";
export const UPDATE_TRANSACTION_MESSAGE = "/updateDetails";
export const REPROCESS_TRANSACTION_MESSAGE = "/processRetry";
export const REPROCESS_EICR_TRANSACTION_MESSAGE = "/procesEICRRetry";
export const TRANSACTION_AUDIT_LOGGING = "/transactionAuditLog";

export const BUSINESS_RULE = "/businessRule";
export const BUSINESS_RULE_LOINC = "/businessRuleLoinc";
export const OBJECTS_DATA = "/refTable/Object";
export const RACE_DATA = "/refTable/Race";
export const REPORT = "/report";
export const DASHBOARD_STATS = "/dashboard";
export const REF_TABLE_REF_TABLE_NAME = "/refTable/refTableName";
export const REF_TABLE_PAGE = "/refTable/page";
export const REF_TABLE_NAME = "/refTableName";
export const GET_REF_TABLE_NAME = "/getRefTableId";
export const QUERY_REFERENCE_TABLE_NAME = "?referenceTableName=";
export const COPY_TO_SENDING_FACILITY_FLAG = "?copyToSendingFacilityFlag=";
export const REF_TABLE_VALUES = "/refTableValues";
export const REF_TABLE = "/refTable";
export const REFERENCE_TABLE_VALUE = "/referenceTableValue";
export const REFERENCE_TABLE_VALUE_CODE = "/referenceTableValueCode";
export const REFERENCE_TABLE_NAME = "/referenceTableName";
export const QAFLAGS = "/QAFlags";
export const CODESET = "/Code Set";
export const ERROR_CODES = "/errorRef";

export const USERS_DATA = "/user/userRoles/page";
export const USER = "/user";
export const USERINFO = "/userInfo";
export const ROLE = "/role";
export const ROLE_PAGE = "/role/page";
export const USER_AUDIT_LOGS = "/userAuditLog/page";
export const TRANSACTION_AUDIT_LOGS = "/transactionAuditLog/page";

//String Constants
export const NO_RECORDS_FOUND = "No Records Found";
export const ERROR_MSG = "Something went wrong, please try again";
export const SUCCESS = "success";

export const OPERATORS = {
  equalTo: "Equal to",
  notEqualTo: "Not Equal to",
  contains: "Contains",
  greaterThan: "Greater than",
  lessThan: "Less than",
  greaterThanOrEqualTo: "Greater than or equal to",
  lessThanOrEqualTo: "Less than or equal to",
  lengthGreaterThan: "Length Greater than",
  lengthLessThan: "Length Less than",
  dateFormatEquals: "Date format equals",
  dateFormatNotEqual: "Date format not equals",
  codeSetValueNotIn: "Code Set Value Not in",
  reTableValueNotIn: "RE Table Value Not in",
};

export const PICK_OPTIONS_DROPDOWN = ["equalTo", "notEqualTo"];

export const PICK_OPTIONS_DROPDOWN_VALIDATION = [
  "equalTo",
  "notEqualTo",
  "codeSetValueNotIn",
];

export const PICK_OPTIONS_AGAINST_TABLES_VALIDATION = [
  "equalTo",
  "notEqualTo",
  "contains",
  "lengthGreaterThan",
  "lengthLessThan",
  "reTableValueNotIn",
];

export const PICK_OPTIONS_STRING = [
  "equalTo",
  "notEqualTo",
  "contains",
  "lengthGreaterThan",
  "lengthLessThan",
];

export const PICK_OPTIONS_NUMERIC = [
  "equalTo",
  "notEqualTo",
  "greaterThan",
  "lessThan",
  "greaterThanOrEqualTo",
  "lessThanOrEqualTo",
];

export const PICK_OPTIONS_DATE = [
  "equalTo",
  "notEqualTo",
  "greaterThan",
  "lessThan",
  "greaterThanOrEqualTo",
  "lessThanOrEqualTo",
  "dateFormatEquals",
  "dateFormatNotEqual",
];

export const HL7_FIELDS_FOR_NUMERIC_VALUES = [
  "spCollDays",
  "onsetDays",
  "age",
  "eventDays",
  "treatmentStoppedDays",
  "closedDays",
  "ageInMonths",
];

export const HL7_FIELDS_FOR_DATE_VALUES = ["PID29", "specimenCollectionDate"];

export const HL7_FIELDS_FOR_DROPDOWN_VALUES = [
  "SPM4",
  // "caseTestResult",
  "existingCase",
  // "PID10.1",
  // "PID8",
  // "PID22.1",
  // "PID30",
  "multipleTierOnePositiveTests",
  "existingCaseNumber",
  "testCombinationResult",
  "hasClosedInvestigationStatus",
  "lockStatus",
  "existingSingleSyphilisTestFlag",
  "caseStatus",
  "caseType",
  "hasExpiredInvestigationCaseStatus",
];

export const CODE_SYSTEM = [
  "HL7 2.5.1",
  "HL7 2.3.1",
  "Local",
  "LOINC (LN)",
  "SNOMED (SCT)",
  "NullFlavor",
  "PHINS VADS",
  "CDC REC",
  "ISO (OID)",
  "ICD-10",
];

export const DATE_FORMAT_OPERATORS = [
  "Date format equals",
  "Date format not equals",
];

export const CODE_SETS_OPERATOR = ["Code Set Value Not in"];

export const RE_TABLES_OPERATOR = ["RE Table Value Not in"];

export const OPERATORS_WITH_RATO = [
  "Greater than",
  "Equal to",
  "Less than",
  "Greater than or equal to",
  "Less than or equal to",
  "Ratio greater than",
  "Ratio greater than or equal to",
  "Ratio less than",
  "Ratio less than or equal to",
  "Ratio equal to",
];

export const OUTPUT_OPTIONS = [
  "Create New Investigation",
  "Update Existing Investigation",
  "Do Not Create Investigation",
  "Potentially Reportable Queue",
  "Reopen Case",
  "Reactor Grid",
  "Merge",
];

export const HAS_EXPIRED_INVESTIGATION_CASE_STATUS ="Has Case been Locked Out%3F";

export const TEST_RESULT_OPTIONS = [
  "Positive",
  "Negative",
  "Indeterminate",
  "Unknown",
  "Resistent",
  "Equivocal"
];
